import React, { useState, useRef, useEffect } from "react";
import { Editor } from "primereact/editor";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

const EditContract = ({handleStep}) => {
  const initialContent = `
<p>This Engagement Agreement (“Agreement”) is made on this … day of …, 2023 at [Delhi, India] by and between:</p>

<p>PLUC Network Private Limited, a company incorporated under the laws of India, having its office at 18 D, Basant Lok, Vasant Vihar, New Delhi – 110057 (hereinafter referred to as the “Company”, “PLUC”, which expression shall, unless it be repugnant to the context or meaning thereof, be deemed to mean and include its successors-in-interest and permitted assigns thereof) of the FIRST PART;</p>

<p>AND</p>

<p>Name, aged about …., and resident of [](hereinafter referred to as the “CREATOR” which expression shall, unless repugnant to the context or the meaning thereof, be deemed to include her/his successors and permitted assigns thereof) of the other Part;</p>

<p>“PLUC” and “CREATOR” are hereinafter collectively referred to as the “Parties” and individually as a “Party”.</p>

<p>WHEREAS:</p>

<p>PLUC is a B2B2C creator economy platform. [CREATOR] is a social media influencer.</p>

<p>PLUC is desirous of engaging the services of [CREATOR] for a set of activities related to the Pluc TV subject to the terms and conditions of the agreement.</p>

<p>NOW THIS AGREEMENT WITNESSES AS UNDER:</p>

<p>DEFINITIONS</p>

<p>Unless contrary to the context or meaning thereof, the following terms shall, wherever capitalized, have the meanings assigned to them below:</p>

<p>“Applicable Law” shall mean all laws, enactments, acts of legislature or parliament, ordinance, statutes, rules, orders, decrees, injunctions, licenses, permits, approvals, authorisations, consents, waivers, privileges, agreements, notifications, guidelines or policies and regulations of any government authority having jurisdiction over the Parties as such are in effect as of the date hereof or as may be amended, modified, re-enacted or revoked from time to time hereafter and includes any administrative interpretation, writ, injunction, directions, directives, judgment, arbitral award, decree orders and international tax treaties, as may be in force from time to time.</p>

<p>“Derivative Rights” shall mean the right to produce Derivative Works based on the Licensed Materials.</p>

<p>“Derivative Works” shall mean all the subsequent works based on the Works and Deliverables developed by the [CREATOR] and/or underlying works including without limitation revision, adaptations, script, literary content, comic books, television/commercial productions, audio clippings, shots (audio or video), commercial works, internet websites, games, etc. in existing or emerging forms or formats.</p>

<p>“IPR” shall mean all patents, copyrights, trade secrets, trade dress, trademarks, trade names, service marks, industrial designs, know-how and any other intellectual property rights granted, created or recognised under Applicable Law, whether registered or unregistered and whether capable of registration or not, including but not limited to rights on (i) works of authorship, including computer programs, architecture, documentation, designs, files, audio-visual content, records, other digital content and data of any nature; (ii) inventions, discoveries, improvements and technology; (iii) proprietary information; (iv) databases, data compilations and collections and technical data; (v) software and financial tools, methods and processes; (vi) schematics and test methodologies; and (vii) any and all instantiations of the foregoing in any language, format or arrangement and embodied in any media.</p>

<p>IN WITNESS WHEREOF, the Parties have executed this Agreement as of the date written above:</p>

<p>_________________________<br />
[ John Doe ]<br />
Client Signature<br />
Date: 17/05/2025</p>
`;


  const [content, setContent] = useState(initialContent);
  const hiddenDivRef = useRef(null);


  return (
    <>
      <div className="sendcontrcat-container p-3">
        <span className="send-title">PROJECT NAME CONTRACT</span>

        <div className="card mt-3">
          <div className="draf-details-conatiner">
            <Editor
              value={content}
              onTextChange={(e) => setContent(e.htmlValue)}
              style={{ height: "auto", width: "100%", minHeight: "200px" }}
            />
          </div>
        </div>

        <div className="d-flex justify-content-start mt-3 gap-2" onClick={handleStep}>
          <button className="send-contract-btn">Send Contract</button>
        </div>

        {/* <div
          ref={hiddenDivRef}
          style={{
            visibility: "hidden",
            position: "absolute",
            zIndex: -1,
            width: "900px",
            padding: "1rem",
            whiteSpace: "normal"
          }}
          dangerouslySetInnerHTML={{ __html: content }}
        /> */}
      </div>
    </>
  );
};

export default EditContract;
